// extracted by mini-css-extract-plugin
export default {"container":"referral-campaign_container__-67b0","referralCollapsibleButton":"referral-campaign_referralCollapsibleButton__8RWY2"};